//Blog
// Blog Box List 
export const blogBoxListData = [
    { id: 1, src: '2.jpg', date: '02', title: 'Encounter every day.', hits: '0 Hits', text: 'A huge part of it is the incomparable beauty you can encounter every day.' },
    { id: 2, src: '3.jpg', date: '03', title: 'Black color is important.', hits: '02 Hits', text: "The simplest things are the most profound. People just don't do it anymore." },
];

//Blog Box Grid
export const blogBoxGridData = [
    {
        id: 1,
        image: "5.jpg",
        date: "20",
        text: 'A huge part of it is the incomparable beauty you can encounter every day.People just anymore profound.'
    },
    {
        id: 2,
        image: "6.jpg",
        date: "9",
        text: "People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound."
    },
    {
        id: 3,
        image: "5.jpg",
        date: "15",
        text: 'A huge part of it is the incomparable beauty you can encounter every day.People just anymore profound.'
    },
    {
        id: 4,
        image: "6.jpg",
        date: "11",
        text: "People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound."
    },
];

// Blog single
export const blogSingleData = [
    { id: 1, src: 'comment.jpg' },
    { id: 2, src: '9.jpg' },
    { id: 3, src: '4.jpg' },
    { id: 4, src: '12.png' },
    { id: 5, src: '14.png' },
];

//Add Post
export const dataTypeahead = [{ name: 'Lifestyle' }, { name: 'Travel' }];

export const postEditRadios = [
    { id: 1, text: 'Text' },
    { id: 2, text: 'Image' },
    { id: 3, text: 'Audio', check: 'checked' },
    { id: 4, text: 'Video' },
];
